import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2ffb0f08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "scroll"
}
const _hoisted_2 = {
  key: 0,
  style: {"font-weight":"600"}
}
const _hoisted_3 = {
  key: 1,
  class: "text-grey-darken-1"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center"
}

import { ref, computed, watch } from 'vue';
import util from '../service/UtilService';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceSelectorComponent',
  props: {
  devices: {
    type: Array,
    required: true
  },
  devicesSearchText: {
    type: String,
    default: ''
  },
  selectAll: {
    type: Boolean,
    default: false
  },
  row: {
    type: Number,
    default: 3
  },
  modelValue: {
    type: Array,
    default: () => []
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const devicesSearch = ref(util.clone(props.devicesSearchText));
const checkAllDevices = ref(props.selectAll);
const selectedDevicesData = ref(props.modelValue);
const valueProps = ref(props.modelValue);

const deviceColProps = computed(() => {
  const cols = props.row === 1 ? 12 : Math.round(12 / props.row);
  return { cols: 12, md: cols };
});

const filteredDevices = computed(() => {
  return props.devices.filter(device => deviceMatch(device));
});

const deviceMatch = (device) => {
  return device.deviceName.toLowerCase().includes(devicesSearch.value?.toLowerCase());
};

const checkAll = (status) => {
  checkAllDevices.value = status;
  selectedDevicesData.value = status ? props.devices.map(device => device['deviceId']) : [];
};

const getDeviceName = (name) => name.length > 29 ? `${name.substring(0, 29)}...` : name;

watch(devicesSearch, () => {
  checkAllDevices.value = selectedDevicesData.value.length === props.devices.length;
});

watch(selectedDevicesData, () => {
  checkAllDevices.value = selectedDevicesData.value.length === props.devices.length;
  emit('update:modelValue', selectedDevicesData.value);
}, { deep: true });

function clearSearch() {
  devicesSearch.value = '';
  checkAllDevices.value = valueProps.value.length === props.devices.length;
}


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (__props.devices.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_text_field, {
          class: "mt-2 bg-white",
          "hide-details": "",
          modelValue: devicesSearch.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((devicesSearch).value = $event)),
          label: "Type to begin filtering...",
          clearable: "",
          onClear: clearSearch,
          density: "compact",
          variant: "outlined"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createVNode(_component_v_checkbox, {
          modelValue: checkAllDevices.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkAllDevices).value = $event)),
          onChange: _cache[2] || (_cache[2] = ($event: any) => (checkAll(checkAllDevices.value))),
          label: "Select All",
          density: "compact",
          "hide-details": "",
          class: "mb-5"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDevices.value, (device) => {
              return (_openBlock(), _createBlock(_component_v_col, _mergeProps({ ref_for: true }, deviceColProps.value, { class: "py-0" }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    density: "compact",
                    modelValue: selectedDevicesData.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedDevicesData).value = $event)),
                    value: device['deviceId'],
                    "hide-details": ""
                  }, {
                    label: _withCtx(() => [
                      (selectedDevicesData.value.includes(device['deviceId']))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(getDeviceName(device['deviceName'])), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(getDeviceName(device['deviceName'])), 1 /* TEXT */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "value"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, "No Devices to choose from."))
}
}

})